import {
    Stack,
    Button,
    RadioGroup,
    FormControlLabel,
    Typography,
    Box,
} from "@mui/material";
import { useEffect } from "react";

import { useCheckout } from "../CheckoutContext";
import SquareRadio from "./SquareRadio";

export default function PaymentStep() {
    const {
        updateSection,
        prevStep,
        checkoutData,
        nextStep,
        setActiveStep,
        setPaymentMethod 
    } = useCheckout();

    const selected = checkoutData.payment.method;
    const isValid = Boolean(selected);

    const nextCard = () => {
        if (selected !== "pix") {
            // O step 3 será renderizado como CreditCardStep devido à lógica no Checkout.js
            setActiveStep(3);
        }
    };

    const handlePaymentChange = (method) => {
        updateSection("payment", { method });
        setPaymentMethod(method);
    };

    return (
        <Stack spacing={3}>
            <Typography variant="h6">Forma de pagamento</Typography>

            <RadioGroup
                value={selected}
                onChange={(e) => handlePaymentChange(e.target.value)}
            >
                {[
                    { value: "pix", label: "PIX (aprovação imediata)" },
                    { value: "debit", label: "Cartão de débito" },
                    { value: "credit", label: "Cartão de crédito" },
                ].map((opt) => (
                    <Box
                        key={opt.value}
                        sx={{
                            border: "1px solid #e5e7eb",
                            borderRadius: 2,
                            px: 2,
                            py: 1.5,
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                            transition: "border 0.15s ease",
                            "&:has(input:checked)": {
                                borderColor: "#1e293b",
                            },
                        }}
                    >
                        <FormControlLabel
                            value={opt.value}
                            control={<SquareRadio />}
                            label={opt.label}
                            sx={{ width: "100%" }}
                        />
                    </Box>
                ))}
            </RadioGroup>

            <Stack direction="row" spacing={2}>
                <Button variant="outlined" onClick={prevStep} fullWidth>
                    Voltar
                </Button>

                {selected !== "pix" && (
                    <Button
                        variant="contained"
                        disabled={!isValid}
                        onClick={nextCard}
                        fullWidth
                    >
                        Continuar
                    </Button>
                )}

                {selected === "pix" && (
                    <Button
                        variant="contained"
                        disabled={!isValid}
                        onClick={nextStep}
                        fullWidth
                    >
                        Revisar pedido
                    </Button>
                )}
            </Stack>
        </Stack>
    );
}
